
import { css } from 'lit';
export default css`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
[hidden] {
  display: none !important;
}
/* Apply component specific CSS */
:host{
}

.dropdown{
}

.dropdown--open .dropdown__panel{
  display:block;
  width:100%;
  padding:0 1rem;
}

.submenu-column{
  flex:1;
  min-width:200px;
  margin-left:var(--spacing-5);
  margin-bottom:1rem;
}

.group-heading{
  font-size:var(--fs-sm);
  line-height:var(--lh-sm);
  text-transform:uppercase;
  margin-top:var(--spacing-1);
  margin-bottom:var(--spacing-2);
  color:var(--gray-professional-lighten-1);
  font-weight:var(--fw-semibold);
}

.submenu-item{
  margin-bottom:var(--spacing-2);
  margin-left:var(--spacing-3);
}

@media (min-width: 1024px){
  .dropdown{
  }

  .dropdown--open .dropdown__panel{
    z-index:11;
    position:absolute;
    pointer-events:all;
    left:0;
    right:0;
    width:100%;
  }
  .submenu-wrapper{
    position:relative;
    background:var(--outline-white);
  }

  .submenu-inner{
    display:flex;
    flex-wrap:wrap;
    -moz-column-gap:var(--spacing-8);
         column-gap:var(--spacing-8);
    position:relative;
    width:calc(
      100% - (200px + (var(--spacing-16) * 2) + (var(--spacing-8) * 2))
    );
    padding-bottom:var(--spacing-8);
    margin:0 auto;
  }

  .submenu-column{
    margin-bottom:0;
    margin-left:0;
  }

  .submenu-item{
    margin-bottom:var(--spacing-3);
    margin-left:0;
  }

  .group-heading{
    margin-top:var(--spacing-8);
    margin-bottom:var(--spacing-5);
  }
}

@media (min-width: 1280px){
  .submenu-column{
    margin-top:var(--spacing-5);
  }
}

.dropdown__trigger{
  position:inherit;
}

ul{
  margin:0;
  padding:0;
  list-style-type:none;
}

a{
  font-size:var(--fs-base);
  line-height:var(--lh-base);
  color:var(--blue-responsible-darken-2);
}
`;